import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import callApi from '../../service/callApi';
import sendRequest from '../../service/sendRequest';
import { removeOpenedProject } from './globalReducer';

const CLEAR_PROJECT_STATUS = 'global/CLEAR_PROJECT_STATUS';
const CLEAR_CONSUMER_PROJECT_STATUS = 'global/CLEAR_CONSUMER_PROJECT_STATUS';

export const clearProjectStatus = createAsyncThunk(
  CLEAR_PROJECT_STATUS,
  async ({ id }, { dispatch, getState, rejectWithValue }) => {
    const openedProjects = getState().global.openedProjects;

    if (!openedProjects.includes(id)) {
      return rejectWithValue(null);
    }

    const response = await sendRequest(() => callApi.delete(`/api/project/status?projectId=${id}`));

    dispatch(removeOpenedProject(id));

    return response.data;
  },
);

export const clearConsumerProjectStatus = createAsyncThunk(
  CLEAR_CONSUMER_PROJECT_STATUS,
  async ({ projectName, projectPassword }, { dispatch, getState, rejectWithValue }) => {
    const openedProjects = getState().global.openedProjects;

    if (!openedProjects.includes(projectName)) {
      return rejectWithValue(null);
    }

    const response = await sendRequest(() =>
      axios.delete(`/api/consumer/project/status`, {
        data: {
          projectName,
          projectPassword,
        },
      }),
    );

    dispatch(removeOpenedProject(projectName));

    return response.data;
  },
);
